import { BlankView } from '../views/blank/blank.view';
import { OrderFormView } from '../views/order-form/order-form.view';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { OrderFormComponent } from './components/order-form/order-form.component';
import { ThankYouComponent } from './components/thank-you/thank-you.component';
import { Redirect } from 'app/order/components/redirect/redirect';
import { OrderFormComponentV2 } from './components/order-form-v2/order-form-v2.component';
import { OrderFormComponentV3 } from './components/order-form-v3/order-form-v3.component';

const OrderRouting: Routes = [
    // login view
    {

        path: 'order-form', component: OrderFormView,
        children: [
            { path: 'product-old/:productID/:cycleID/:yardAddOn', component: OrderFormComponent },
            { path: 'product-old/:productID/:cycleID/:yardAddOn/:marketTag', component: OrderFormComponent },
            { path: 'product/:productID/:cycleID/:yardAddOn', component: OrderFormComponentV3 },
            { path: 'product/:productID/:cycleID/:yardAddOn/:marketTag', component: OrderFormComponentV3 },

            { path: 'thank-you', component: ThankYouComponent },
            { path: 'thank-you/:marketTag', component: ThankYouComponent },

            // { path: 'dashboard1', component: SupportDashboard1Component },

            // handle all other routes
            { path: '**', component: OrderFormComponentV3 }
        ]
    },

    // dashboard views
    {
        path: 'redirect', component: BlankView,
        children: [
            { path: ':redirectID', component: Redirect }
        ]
    },
];


@NgModule({
    imports: [RouterModule.forChild(OrderRouting)],
    exports: [RouterModule]
})
export class OrderRoutingModule {

}
